const STAKEWISE_ROUTES = {
  CORE: {
    NAME: 'Stakewise',
    PATH: 'stakewise'
  },
  REWARDS: {
    NAME: 'StakewiseRewards',
    PATH: 'rewards'
  },
  STAKE: {
    NAME: 'StakewiseStake',
    PATH: 'stake'
  }
};
export { STAKEWISE_ROUTES };
